import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { PerformanceProvider } from "./context/PerformanceContext";
import useTawkTo from "@/hooks/useTawkTo";


function App() {
  useTawkTo();
  return (
    <I18nextProvider i18n={i18n}>
      <PerformanceProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      </PerformanceProvider>
    </I18nextProvider>
  );
}

export default App;